// Helpers de exportacao de relatorio — Excel (CSV compat) e PDF (window.print).
// Sem dependencias externas: CSV client-side, PDF via impressao do navegador
// filtrada por elemento (data-print-scope="id").

/** Baixa um array de linhas como CSV UTF-8 (com BOM) — Excel/Sheets abrem
 *  respeitando acentos e virgula/ponto. `headers` define a ordem e o rotulo. */
export function downloadCsv<T>(
  filename: string,
  rows: T[],
  headers: { key: keyof T; label: string; format?: (v: unknown, row: T) => string }[],
): void {
  const escape = (raw: unknown): string => {
    const s = raw == null ? "" : String(raw);
    // Escapa quotes duplicando + envolve com quotes se tem , " ou newline.
    if (/["\n,;]/.test(s)) return `"${s.replace(/"/g, '""')}"`;
    return s;
  };
  const linhas: string[] = [];
  linhas.push(headers.map((h) => escape(h.label)).join(";"));
  for (const r of rows) {
    linhas.push(
      headers
        .map((h) => escape(h.format ? h.format((r as Record<string, unknown>)[h.key as string], r) : (r as Record<string, unknown>)[h.key as string]))
        .join(";"),
    );
  }
  // BOM UTF-8 pro Excel abrir com acentos corretos.
  const csv = "﻿" + linhas.join("\r\n");
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename.endsWith(".csv") ? filename : `${filename}.csv`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}

/** Abre a janela de impressao do navegador SO com o elemento marcado com
 *  data-print-scope=<scope>. O usuario escolhe "Salvar como PDF" no dialogo. */
export function printScope(scope: string, title?: string): void {
  const alvo = document.querySelector<HTMLElement>(`[data-print-scope="${scope}"]`);
  if (!alvo) return;
  // Injeta estilo temporario pra esconder tudo fora do escopo.
  const styleId = `__print_scope_${scope}`;
  const anterior = document.getElementById(styleId);
  if (anterior) anterior.remove();
  const style = document.createElement("style");
  style.id = styleId;
  style.textContent = `
    @media print {
      body * { visibility: hidden !important; }
      [data-print-scope="${scope}"], [data-print-scope="${scope}"] * { visibility: visible !important; }
      [data-print-scope="${scope}"] { position: absolute; left: 0; top: 0; width: 100%; background: white; color: black; padding: 24px; }
      [data-print-scope="${scope}"] * { color: black !important; background: transparent !important; border-color: #ccc !important; }
      [data-print-scope="${scope}"] button, [data-print-scope="${scope}"] .no-print { display: none !important; }
      @page { size: A4; margin: 12mm; }
    }
  `;
  document.head.appendChild(style);
  const prevTitle = document.title;
  if (title) document.title = title;
  window.print();
  // Limpa depois. onafterprint nem sempre dispara em todos os navegadores,
  // entao usa setTimeout tambem como fallback.
  const limpar = () => {
    style.remove();
    if (title) document.title = prevTitle;
    window.removeEventListener("afterprint", limpar);
  };
  window.addEventListener("afterprint", limpar);
  setTimeout(limpar, 2000);
}
